/**
 * Katalog fraz lektora TTS (klucz → tekst PL).
 * Synchronizowany z tools/tts/catalog.json — przy dodawaniu fraz
 * zaktualizuj oba miejsca i uruchom: python tools/tts/generate.py
 */

/** Baza URL plików ogg (Vite public/). */
export const TTS_AUDIO_BASE = '/assets/audio/tts';

export const TTS_CATALOG: Readonly<Record<string, string>> = {
  place_town: 'Miasteczko',
  place_park: 'Park',
  place_house: 'Domek',
  place_wardrobe: 'Salon Piękności',
  place_cafe: 'Kawiarnia Kość',
  place_shop: 'Sklep z ubrankami',
  place_school: 'Szkoła',
  place_pool: 'Basen',
  place_stable: 'Stajnia',
  place_garden_gate: 'Ogród marzeń, brama',
  place_garden: 'Ogród marzeń',
  place_vet: 'Weterynarz',
  place_icecream: 'Lodziarnia',
  place_osiedle: 'Osiedle',
  place_rynek: 'Rynek Łapki',
  place_pole: 'Pole, stajnia i basen',
  place_salon: 'Salon',

  ui_buy: 'Kup',
  ui_wear: 'Załóż',
  ui_save: 'Zapisz',
  ui_next: 'Dalej',
  ui_back: 'Wróć',
  ui_play: 'Zagraj',
  ui_super: 'Super!',
  ui_yes: 'Tak',
  ui_no: 'Nie',
  ui_cancel: 'Anuluj',
  ui_exit: 'Wyjdź',
  ui_retry: 'Jeszcze raz',
  ui_start: 'Zaczynamy!',
  ui_spin: 'Zakręć!',
  ui_again: 'Ponów',
  ui_to_town: 'Do miasteczka!',
  ui_build: 'Buduj',
  ui_town: 'Miasteczko',
  ui_new_account: 'Nowe konto',
  ui_have_account: 'Mam już konto',
  ui_back_arrow: 'Wstecz',
  ui_save_sparkle: 'Zapisz',
  ui_delete_profile: 'Usuń profil',
  ui_live_together: 'Zamieszkaj',
  ui_music_on: 'Muzyka włączona',
  ui_music_off: 'Muzyka wyłączona',
  ui_sfx_on: 'Dźwięki włączone',
  ui_sfx_off: 'Dźwięki wyłączone',
  ui_narrator_on: 'Lektor włączony',
  ui_narrator_off: 'Lektor wyłączony',
  ui_dogs: 'Pieski',
  ui_games: 'Gierki',
  ui_together: 'Razem',
  ui_sound: 'Dźwięk',
  ui_close: 'Zamknij',
  ui_dog: 'Piesek',
  ui_dragon: 'Smok',
  ui_sit: 'Siad',
  ui_jump: 'Skok',
  ui_wave: 'Pa pa',
  ui_eat: 'Jedz',
  ui_happy: 'Hurra',
  ui_sleep: 'Śpij',
  ui_back_to_house: 'Wróć do domku',
  ui_back_to_town: 'Wróć do miasteczka',
  ui_to_pool: 'Do basenu',
  ui_buy_ice: 'Kup loda',
  ui_puzzle_3: 'Puzzle trzy na trzy',
  ui_puzzle_4: 'Puzzle cztery na cztery',
  ui_swim_race: 'Wyścig pływacki',
  ui_bubbles: 'Bąbelki',
  ui_puzzle: 'Puzzle',
  ui_brawo: 'Brawo!',
  ui_well_done: 'Świetnie!',
  ui_try_again: 'Spróbuj jeszcze raz',
  ui_not_enough: 'Za mało złotówek',
  ui_need_network: 'Potrzebna sieć do zakupów',
  ui_need_login: 'Zaloguj się, żeby kupować',
  ui_offline_reward:
    'Nie udało się zapisać tej nagrody. Zagraj ponownie, gdy internet wróci.',
  ui_play_longer: 'Zagraj chwilę dłużej!',
  ui_super_house: 'Super domek!',
  ui_reward_today: 'Nagroda za budowanie już dziś odebrana',

  mg_rhythm: 'Bau-Bau Rytm',
  mg_cooking: 'Kuchnia Kości',
  mg_runner: 'Wyścig Piesków',
  mg_bubbles: 'Bąbelki',
  mg_puzzle: 'Puzzle',
  mg_swimrace: 'Wyścig pływacki',

  item_dress_pink: 'Różowa sukienka',
  item_shirt_blue: 'Niebieska bluzka',
  item_hat_sun: 'Kapelusz słoneczny',
  item_hat_party: 'Czapeczka imprezowa',
  item_bow_red: 'Czerwona kokardka',
  item_bow_blue: 'Niebieska kokardka',
  item_glasses_round: 'Okrągłe okulary',
  item_collar_gold: 'Złota obroża',
  item_collar_heart: 'Obroża z serduszkiem',
  item_shoes_pink: 'Różowe buciki',
  item_acc_bag: 'Torebeczka',
  item_acc_star: 'Gwiazdka',
  item_suit_pink: 'Różowy strój kąpielowy',
  item_suit_stripes: 'Paski kąpielowe',
  item_cap_blue: 'Niebieski czepek',
  item_dress_blue: 'Niebieska sukienka',
  item_dress_flowers: 'Sukienka w kwiatki',
  item_tshirt_stripes: 'Koszulka w paski',
  item_raincoat_yellow: 'Żółty płaszczyk przeciwdeszczowy',
  item_sweater_green: 'Zielony sweterek',
  item_hat_crown: 'Korona',
  item_hat_beret: 'Beret',
  item_hat_winter: 'Czapka zimowa',
  item_bow_pink_big: 'Duża różowa kokardka',
  item_bow_star: 'Kokardka z gwiazdką',
  item_bandana_blue: 'Niebieska bandamka',
  item_glasses_sun: 'Okulary przeciwsłoneczne',
  item_glasses_heart: 'Okulary w serduszka',
  item_collar_bell: 'Obroża z dzwoneczkiem',
  item_collar_flowers: 'Obroża w kwiatki',
  item_shoes_rain: 'Kalosze',
  item_shoes_sport: 'Sportowe buciki',
  item_acc_backpack: 'Plecaczek',
  item_acc_scarf: 'Szaliczek',
  item_acc_wings: 'Skrzydełka',
  item_suit_dots: 'Strój kąpielowy w kropki',

  obj_cafe_cupcake: 'Ciastko',
  obj_cafe_espresso: 'Ekspres do kawy',
  obj_cafe_tray: 'Taca',
  obj_cafe_pitcher: 'Dzbanek',
  obj_cafe_chair: 'Krzesełko',
  obj_cafe_bell: 'Dzwonek',
  obj_cafe_menu: 'Menu',
  obj_cafe_sugar: 'Cukier',
  obj_cafe_plant: 'Roślinka',
  obj_school_backpack: 'Plecak',
  obj_school_crayon: 'Kredka',
  obj_school_eraser: 'Gumka',
  obj_school_block: 'Klocek',
  obj_school_block_a: 'Klocek',
  obj_school_block_b: 'Klocek',
  obj_school_block_c: 'Klocek',
  obj_school_block_d: 'Klocek',
  obj_school_bell: 'Dzwonek szkolny',
  obj_school_desk: 'Ławka',
  obj_school_globe: 'Globus',
  obj_pool_cabin: 'Przebieralnia',
  obj_pool_lounger: 'Leżak',
  obj_pool_ball: 'Piłka basenowa',
  obj_pool_ring: 'Koło do pływania',
  obj_pool_shower: 'Prysznic',
  obj_pool_trampoline: 'Trampolina',
  obj_pool_splash: 'Plusk',
  obj_pool_towel: 'Ręcznik',
  obj_pool_umbrella: 'Parasol',
  obj_house_food_bag: 'Workek karmy',
  obj_house_bowl: 'Miska',
  obj_house_fridge: 'Lodówka',
  obj_house_treat: 'Smakołyk',
  obj_house_tv: 'Telewizor',
  obj_house_console: 'Konsola',
  obj_house_bed: 'Łóżeczko',
  obj_house_blocks_box: 'Pudełko klocków',
  obj_house_figure: 'Figurka',
  obj_house_figure_red: 'Figurka',
  obj_house_figure_blue: 'Figurka',
  obj_house_figure_green: 'Figurka',
  obj_house_figure_yellow: 'Figurka',
  obj_house_lamp: 'Lampka',
  obj_house_window: 'Okienko',
  obj_house_cat: 'Kot w domku',
  obj_town_ball: 'Piłka',
  obj_town_puddle: 'Kałuża',
  obj_town_bench: 'Ławeczka',
  obj_town_lamp: 'Latarnia',
  obj_town_bird: 'Ptaszek',
  obj_town_flowerbox: 'Skrzynka z kwiatami',
  obj_town_fountain: 'Fontanna',
  obj_town_street_cat: 'Kotek na ulicy',
  obj_town_cat: 'Kotek na ulicy',
  obj_stable_bucket: 'Wiadro',
  obj_stable_apple: 'Jabłuszko',
  obj_stable_ladder: 'Drabinka',
  obj_stable_hay: 'Bele siana',
  obj_stable_brush: 'Szczotka',
  obj_stable_carrot: 'Marchewka',
  obj_stable_wheelbarrow: 'Taczka',
  obj_stable_horseshoe: 'Podkowa',
  obj_stable_horse_iskierka: 'Iskierka',
  obj_stable_horse_chmurka: 'Chmurka',
  obj_garden_treat: 'Smakołyk w ogrodzie',
  obj_garden_waterfall: 'Wodospad',
  obj_garden_blanket: 'Kocyk',
  obj_garden_rod: 'Wędka',
  obj_garden_stream: 'Rzeczka',
  obj_garden_lily: 'Lilie wodne',
  obj_garden_basket: 'Koszyk',
  obj_garden_butterfly: 'Motyl',
  obj_garden_net: 'Siatka',
  obj_garden_flower_rose: 'Róża',
  obj_garden_flower_tulip: 'Tulipan',
  obj_garden_flower_daisy: 'Stokrotka',
  obj_garden_flower_sunflower: 'Słonecznik',
  obj_garden_fish_gold: 'Złota rybka',
  obj_garden_fish_blue: 'Niebieska rybka',
  obj_garden_fish_pink: 'Różowa rybka',
  obj_garden_fish_green: 'Zielona rybka',
  obj_park_slide: 'Zjeżdżalnia',
  obj_park_swing: 'Huśtawka',
  obj_park_sandbox: 'Piaskownica',
  obj_park_sandcake: 'Babka z piasku',
  obj_park_bench: 'Ławka',
  obj_shop_curtain: 'Kotara',
  obj_shop_register: 'Kasa',
  obj_shop_bell: 'Dzwonek w sklepie',
  obj_shop_bag: 'Torebka',
  obj_shop_mirror: 'Lustro',
  obj_shop_hanger_stand: 'Wieszak',
  obj_vet_patient: 'Pacjent',
  obj_vet_stethoscope: 'Stetoskop',
  obj_vet_plaster: 'Plaster',
  obj_vet_medicine: 'Lekarstwo',
  obj_vet_plant: 'Roślinka lecznicza',
  // Demo interact (PL)
  obj_ciastko: 'Ciastko',
  obj_pilka: 'Piłka',
  obj_dzwonek: 'Dzwonek',
  obj_kwiatek: 'Kwiatek',
  obj_miska: 'Miska',
  obj_kubek: 'Kubek',

  flavor_strawberry: 'Truskawkowy',
  flavor_chocolate: 'Czekoladowy',
  flavor_vanilla: 'Waniliowy',
  flavor_mint: 'Miętowy',

  quest_cafe_cupcakes: 'Podaj trzy ciastka gościom',
  quest_school_blocks: 'Ułóż trzy klocki na półce',
  quest_stable_feed: 'Nakarm oba koniki',
  quest_wardrobe_hats: 'Przymierz dwie czapki',
  quest_house_feed: 'Nakarm pieska z miski',
  quest_pool_trampoline: 'Skocz z trampoliny do wody',
  quest_garden_fish: 'Złów jedną rybkę',
  quest_town_pet_cat: 'Pogłaszcz kotka na ulicy',
  quest_park_ball: 'Kopnij piłkę trzy razy',
  quest_shop_tryon: 'Przymierz ubranko w sklepie',

  msg_miau: 'Miau!',
  msg_hello: 'Cześć!',
  msg_welcome: 'Witaj w Pieskowie!',
  msg_good_job: 'Dobra robota!',
  msg_yummy: 'Pycha!',
  msg_splash: 'Plusk!',
  msg_gold: 'Złotówki!',
  msg_reward: 'Nagroda!',
  msg_loading: 'Ładowanie',
  msg_ready: 'Gotowe!',
};

/** Normalizacja etykiety UI do porównań (emoji, strzałki, spacje). */
export function normalizeLabel(text: string): string {
  return text
    .normalize('NFC')
    .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '')
    .replace(/[←→▶◀✨🎡🧩🫧🏊🔑🐶🐉✕✓·•]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

/** Mapa znormalizowany tekst → klucz (do dopasowania etykiet przycisków). */
const textToKey = (() => {
  const m = new Map<string, string>();
  for (const [key, text] of Object.entries(TTS_CATALOG)) {
    const n = normalizeLabel(text);
    if (n && !m.has(n)) m.set(n, key);
  }
  // Aliasy częstych etykiet z emoji / strzałkami
  const aliases: Record<string, string> = {
    'kup': 'ui_buy',
    'załóż': 'ui_wear',
    'zaloz': 'ui_wear',
    'zapisz': 'ui_save',
    'dalej': 'ui_next',
    'wróć': 'ui_back',
    'wroc': 'ui_back',
    'wstecz': 'ui_back_arrow',
    'zagraj': 'ui_play',
    'super!': 'ui_super',
    'super': 'ui_super',
    'tak': 'ui_yes',
    'nie': 'ui_no',
    'anuluj': 'ui_cancel',
    'wyjdź': 'ui_exit',
    'wyjdz': 'ui_exit',
    'wyjście': 'ui_exit',
    'wyjscie': 'ui_exit',
    'jeszcze raz': 'ui_retry',
    'zaczynamy!': 'ui_start',
    'zaczynamy': 'ui_start',
    'zakręć!': 'ui_spin',
    'zakrec!': 'ui_spin',
    'zakręć': 'ui_spin',
    'ponów': 'ui_again',
    'ponow': 'ui_again',
    'do miasteczka!': 'ui_to_town',
    'do miasteczka': 'ui_to_town',
    'buduj': 'ui_build',
    'miasteczko': 'place_town',
    'nowe konto': 'ui_new_account',
    'mam już konto': 'ui_have_account',
    'mam juz konto': 'ui_have_account',
    'usuń profil': 'ui_delete_profile',
    'usun profil': 'ui_delete_profile',
    'zamieszkaj': 'ui_live_together',
    'pieski': 'ui_dogs',
    'gierki': 'ui_games',
    'razem': 'ui_together',
    'dźwięk': 'ui_sound',
    'dzwiek': 'ui_sound',
    'piesek': 'ui_dog',
    'smok': 'ui_dragon',
    'siad': 'ui_sit',
    'skok': 'ui_jump',
    'pa pa': 'ui_wave',
    'jedz': 'ui_eat',
    'hurra': 'ui_happy',
    'śpij': 'ui_sleep',
    'spij': 'ui_sleep',
    'wróć do domku': 'ui_back_to_house',
    'wroc do domku': 'ui_back_to_house',
    'wróć do miasteczka': 'ui_back_to_town',
    'wroc do miasteczka': 'ui_back_to_town',
    'do basenu': 'ui_to_pool',
    'kup loda': 'ui_buy_ice',
    'puzzle': 'ui_puzzle',
    'bąbelki': 'ui_bubbles',
    'babelki': 'ui_bubbles',
    'wyścig pływacki': 'ui_swim_race',
    'wyscig pływacki': 'ui_swim_race',
    'wyscig plywacki': 'ui_swim_race',
    'park': 'place_park',
    'domek': 'place_house',
    'basen': 'place_pool',
    'szkoła': 'place_school',
    'szkola': 'place_school',
    'stajnia': 'place_stable',
    'sklep z ubrankami': 'place_shop',
  };
  for (const [alias, key] of Object.entries(aliases)) {
    if (!m.has(alias)) m.set(alias, key);
  }
  return m;
})();

export function catalogText(key: string): string | undefined {
  return TTS_CATALOG[key];
}

export function catalogKeyForText(text: string): string | undefined {
  const n = normalizeLabel(text);
  if (!n) return undefined;
  return textToKey.get(n);
}

export function ttsUrl(key: string): string {
  return `${TTS_AUDIO_BASE}/${key}.ogg`;
}
